<div class="view-container">
  <div class="top-bar">
    <span class="label"></span>
    <customer-portal-kc-localization-menu
      class="localizationMenu"
    ></customer-portal-kc-localization-menu>
  </div>
  <div class="login">
    <div class="form-container">
      <form
        #companyRequestChangeForm
        [formGroup]="form"
        method="POST"
        (ngSubmit)="login()"
      >
        <div class="street">
          <h2 class="ef-headline-3">
            <T
              str="Review company details"
              key="customerPortal.kc.company-request-change.title"
              tags="kc-forms, 3.1"
            ></T>
          </h2>
          <a class="back-button"
            ><button
              type="submit"
              (click)="form.patchValue({ action: 'back' })"
            >
              <mat-icon color="primary">arrow_back</mat-icon>
            </button>
            <T
              str="Back to original details"
              key="customerPortal.kc.edit-business.back"
              tags="kc-forms, 3.1"
            ></T>
          </a>
        </div>
        <mat-form-field class="company-name">
          <mat-label>
            <T
              str="Company name"
              key="customerPortal.kc.presonalize.company-name"
              tags="kc-forms, 3.1"
            ></T>
          </mat-label>
          <input
            class="input"
            matInput
            type="text"
            required
            formControlName="companyName"
            name="companyName"
          />
          <mat-icon
            *ngIf="
              form.controls.companyName.touched &&
              form.controls.companyName.invalid
            "
            matSuffix
            color="error"
            svgIcon="error_outline"
          ></mat-icon>
          <mat-error *ngIf="form.controls.companyName.invalid">
            {{
              transifexService.getErrorTranslation(
                form.controls.companyName,
                'customerPortal.kc.personalize.company-name.error.'
              )
            }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="street">
          <mat-label>
            <T
              str="Uid"
              key="customerPortal.kc.review-business.uid"
              tags="kc-forms, 3.1"
            ></T>
          </mat-label>
          <input
            class="input"
            matInput
            type="text"
            required
            formControlName="companyNumber"
            name="companyNumber"
          />
          <mat-icon
            *ngIf="
              form.controls.companyNumber.touched &&
              form.controls.companyNumber.invalid
            "
            matSuffix
            color="error"
            svgIcon="error_outline"
          ></mat-icon>
        </mat-form-field>
        <mat-form-field class="street">
          <mat-label>
            {{ 'address' | sharedTranslate }}
          </mat-label>
          <input
            class="input"
            matInput
            type="text"
            required
            formControlName="address"
            name="address"
          />
          <mat-icon
            *ngIf="
              form.controls.address.touched && form.controls.address.invalid
            "
            matSuffix
            color="error"
            svgIcon="error_outline"
          ></mat-icon>
          <mat-error *ngIf="form.controls.address.invalid">
            {{
              transifexService.getErrorTranslation(
                form.controls.address,
                'customerPortal.kc.personalize.street.error.',
                {
                  num: remoteConfigService.get(
                    'regEx.addressRegEx.street.maxLength'
                  ),
                  errKey: {
                    maxlength: 'max-length-characters',
                    pattern: 'only-numbers-letters-allowed'
                  }
                }
              )
            }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="zip">
          <mat-label>
            <T
              str="Postal code"
              key="customerPortal.kc.presonalize.zip"
              tags="kc-forms, 3.1"
            ></T>
          </mat-label>
          <input
            class="input"
            matInput
            type="number"
            required
            formControlName="zip"
            name="zip"
          />
          <mat-icon
            *ngIf="form.controls.zip.touched && form.controls.zip.invalid"
            matSuffix
            color="error"
            svgIcon="error_outline"
          ></mat-icon>
          <mat-error
            *ngIf="
              form.get('zip').errors &&
              !form.get('zip').errors.hasOwnProperty('pattern')
            "
          >
            {{
              transifexService.getErrorTranslation(
                form.controls.zip,
                'customerPortal.kc.personalize.zip.error.',
                {
                  num: remoteConfigService.get(
                    'regEx.addressRegEx.zip.maxLength'
                  ),
                  errKey: {
                    minlength: 'required-length-characters',
                    maxlength: 'required-length-characters',
                    pattern: 'only-numbers-allowed'
                  }
                }
              )
            }}
          </mat-error>
          <mat-error
            *ngIf="
              form.get('zip').errors &&
              form.get('zip').errors.hasOwnProperty('pattern')
            "
          >
            {{ 'invalid-number' | sharedTranslate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="city">
          <mat-label>
            {{ 'city' | sharedTranslate }}
          </mat-label>
          <input
            class="input"
            matInput
            type="text"
            required
            formControlName="city"
            name="city"
          />
          <mat-icon
            *ngIf="form.controls.city.touched && form.controls.city.invalid"
            matSuffix
            color="error"
            svgIcon="error_outline"
          ></mat-icon>
          <mat-error *ngIf="form.controls.city.invalid">
            {{
              transifexService.getErrorTranslation(
                form.controls.city,
                'customerPortal.kc.personalize.city.error.',
                {
                  num: remoteConfigService.get(
                    'regEx.addressRegEx.city.maxLength'
                  ),
                  errKey: {
                    maxlength: 'max-length-characters',
                    pattern: 'only-numbers-letters-allowed'
                  }
                }
              )
            }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="country">
          <mat-label>
            {{ 'country' | sharedTranslate }}
          </mat-label>
          <mat-select class="ef-select" formControlName="country">
            <mat-option
              *ngFor="let c of countries"
              [id]="c.code"
              [value]="c.code.toUpperCase()"
            >
              {{ c.code.toLowerCase() | sharedTranslate }}
            </mat-option>
          </mat-select>
          <mat-icon
            *ngIf="
              form.controls.country.touched && form.controls.country.invalid
            "
            matSuffix
            color="error"
            svgIcon="error_outline"
          ></mat-icon>
        </mat-form-field>
        <div class="personalize-button">
          <button
            mat-button
            mat-flat-button
            color="primary"
            type="submit"
            (click)="form.patchValue({ action: 'finish' })"
            [disabled]="!form.valid"
          >
            <input type="hidden" name="action" [value]="form.value.action" />
            <div class="button-spinner">
              <span>
                <T
                  str="Submit & Finish"
                  key="customerPortal.kc.edit-business.submit-finish"
                  tags="kc-forms, 3.1"
                ></T>
              </span>
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
